import Vue from 'vue';
import BasicBlock from './BasicBlock';

export default Vue.component('smart-suggest-block-suggestion', {
    template: `        
      <smart-suggest-block :icon="icon" :name="blockName" v-if="blockName && suggestions.length > 0">
        <ul class="fl-as-smart-suggest-list-container fl-as-text-list-container">
          <li v-for="suggestion in suggestions"
              class="fl-as-smart-suggest-list-option fl-as-text-list-option" 
              v-html="getHighlightedName(suggestion.text)"
              @click="$emit('submit', suggestion)"
          />
        </ul>
      </smart-suggest-block>
    `,
    inject: ['config', 'HandleShopInteractionService', 'utils'],
    props: { suggestions: Array, icon: String, blockName: String },
    components: {
        basic: BasicBlock,
    },
    methods: {
        getHighlightedName(suggestion: string): string {
            return this.config.assistedSuggest.config.highlightMatchesInSuggestions
                ? this.utils.generateHighlightedHtml(suggestion, this.HandleShopInteractionService.getActiveInputValue())
                : this.utils.escapeUserProvidedText(suggestion);
        },
    },
});
